import { render } from "./JobPurposeSection.vue?vue&type=template&id=415161ba"
import script from "./JobPurposeSection.vue?vue&type=script&lang=js"
export * from "./JobPurposeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__